import StudentPlanRejectedComponent from './rejected.component';


export default angular
  .module('fizyweb.paycell.student.rejected', [])
  .component('rejected', StudentPlanRejectedComponent).name;



// WEBPACK FOOTER //
// src/app/components/student/rejected/rejected.module.ts